"use strict";
/**
 * ibantools-germany
 * Copyright (C) 2022-2023 Markus Baumer <markus@baumer.dev>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.

 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const helper_1 = require("../helper");
const method00_1 = require("./method00");
exports.default = (number) => {
    const paddedNumber = (0, helper_1.paddedAccountNumber)(number);
    const firstDigit = Number(paddedNumber.slice(0, 1));
    if (isNaN(firstDigit) || firstDigit === 8) {
        return "INVALID";
    }
    const leftFillConsts = [
        4363380, 4363381, 4363382, 4363383, 4363384, 4363385, 4363386, 4363387, -1,
        4363389,
    ];
    return (0, method00_1.method00Core)(`${leftFillConsts[firstDigit]}${paddedNumber.slice(1, 10)}`, [2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2]);
};
